import { render, staticRenderFns } from "./CategoriesManage.vue?vue&type=template&id=3a42cd6b&scoped=true&"
import script from "./CategoriesManage.vue?vue&type=script&lang=js&"
export * from "./CategoriesManage.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesManage.vue?vue&type=style&index=0&id=3a42cd6b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a42cd6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
